import { render, staticRenderFns } from "./overPaymentDataTable.vue?vue&type=template&id=88ff2a84&"
import script from "./overPaymentDataTable.vue?vue&type=script&lang=js&"
export * from "./overPaymentDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports